import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { AppModule } from "@/store/modules/app";
import { UserModule } from "@/store/modules/user";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import Hamburger from "@/components/Hamburger/index.vue";
let default_1 = class extends Vue {
    get sidebar() {
        return AppModule.sidebar;
    }
    get device() {
        return AppModule.device.toString();
    }
    get avatar() {
        return require("@/assets/avatar.gif");
    }
    toggleSideBar() {
        AppModule.ToggleSideBar(false);
    }
    logout() {
        UserModule.logout();
        // redirectLogin();
    }
};
default_1 = tslib_1.__decorate([
    Component({
        name: "Navbar",
        components: {
            Breadcrumb,
            Hamburger,
        },
    })
], default_1);
export default default_1;
